import { createFileRoute } from '@tanstack/react-router'
import { NewJobDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import EditJobDialog from '@/routes/_app/-dialogs/edit-job'

export const Route = createFileRoute('/@modal/jobs/new')({
  staticData: { slotScope: '/_app' },
  pendingComponent: NewJobDialogPending,
  component: NewJobSlot,
})

function NewJobSlot() {
  const slot = useModalSlot(Route)
  return <EditJobDialog {...slot} />
}
